import {Intent, MoneyColor, MonthDetails, Transaction} from "./types";

export function getIntentPaidTransactions(monthDetails: MonthDetails, intent: Intent): Array<Transaction> {
  const transactions: Array<Transaction> = []
  for (let i = 0; i < monthDetails.transactions.length; i++) {
    if (intent.id === monthDetails.transactions[i].intentId)
      transactions.push(monthDetails.transactions[i])
  }
  return transactions
}

export function transactionMainColor(mainPocketId: string, transaction: Transaction): MoneyColor | undefined {
  if (transaction.toPocketId === mainPocketId) {
    return MoneyColor.Income
  }
  if (transaction.fromPocketId === mainPocketId) {
    return MoneyColor.Expense
  }
  return undefined
}

export function transactionMainAmount(mainPocketId: string, transaction: Transaction): number | undefined {
  const color = transactionMainColor(mainPocketId, transaction)
  if (color === MoneyColor.Income) {
    return transaction.amount
  }
  if (color === MoneyColor.Expense) {
    return -transaction.amount
  }
  return undefined
}
